import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

export interface ITemplate
{
  name: string;
  grid?: string;
  minorGrid?: string;
  background?: string;
  candleBorder?: string;
  bearishCandle?: string;
  bullishCandle?: string;
  axis?: string;
  font?: string;
  chartingPriceline?: string;
  crosshair?: string;
}

export class Template implements ITemplate
{
  name: string = 'New template';
  grid?: string;
  minorGrid?: string;
  background?: string;
  candleBorder?: string;
  bearishCandle?: string;
  bullishCandle?: string;
  axis?: string;
  font?: string;
  chartingPriceline?: string;
  crosshair?: string;
}

@Component({
  selector: 'template-preview',
  template: require('./template-preview.component.html'),
  styles: [require('./template-preview.component.css')]
})
export class TemplatePreviewComponent implements OnInit {

  @Input() 
  set template(v:ITemplate)
  {
    if(v.grid) this.setStroke('.grid', v.grid);
    if(v.minorGrid) this.setStroke('.minor-grid', v.minorGrid);
    if(v.background) this.setFill('.background', v.background);
    if(v.candleBorder) this.setStroke('.candle-border', v.candleBorder);
    if(v.bearishCandle) this.setFill('.bearish-candle', v.bearishCandle);
    if(v.bullishCandle) this.setFill('.bullish-candle', v.bullishCandle);
    if(v.axis) this.setStroke('.axis', v.axis);
    if(v.font) this.setFill('.font', v.font);
    if(v.chartingPriceline) this.setFill('.charting-priceline', v.chartingPriceline);
  }

  chartWidthPx = 684;
  chartHeightPx = 429;

  get scaleX()
  {
    return this.elementRef.nativeElement.offsetWidth/this.chartWidthPx;
  }

  get scaleY()
  {
    return this.elementRef.nativeElement.offsetHeight/this.chartHeightPx;
  }

  get transform()
  {
    return this.sanitizer.bypassSecurityTrustStyle('scaleX(' + this.scaleX + ') scaleY(' + this.scaleY + ')');
  }
  constructor(public elementRef: ElementRef, public sanitizer: DomSanitizer) { }

  ngOnInit() {
  }

  setStroke(selector: string, stroke: string)
  {
    this.select(selector).forEach(e => (e as any).setAttribute('stroke', stroke))
  }

  setFill(selector: string, fill: string)
  {
    this.select(selector).forEach(e => (e as any).setAttribute('fill', fill))
  }

  select(selector: string): NodeList
  {
    return this.elementRef.nativeElement.querySelectorAll(selector);
  }

}
